import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { NavigationEnd, NavigationExtras, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {

  private readonly history: string[] = [];

  public get canGoBack(): boolean {
    return this.history.length > 1;
  }

  constructor(
    private readonly router: Router,
    private readonly location: Location
  ) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(event => this.addUrl(event.urlAfterRedirects));
  }

  public back(fallback: any[] = ['/'], extras?: NavigationExtras): void {
    if (!this.canGoBack) {
      this.router.navigate(fallback, extras);
      return;
    }

    this.history.pop();
    this.location.back();
  }

  private addUrl(url: string): void {
    if (this.router.currentNavigation()?.extras.replaceUrl && this.history.length) {
      this.history[this.history.length - 1] = url;
      return;
    }

    this.history.push(url);
  }
}
